const styles = theme => ({
  content: {
    display: 'flex',
  },
  form: {
    flex: '1 0 0',
  },
  title: {
    marginTop: theme.spacing(),
    marginBottom: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  noPadding: {
    padding: 0,
  },
  noOverflowX: {
    overflowX: 'hidden',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch',
  },
});

export default styles;
